module.exports = __webpack_public_path__ + "static/media/TERMOS E CONDIÇÕES DE VENDA DE PRODUTOS ESSILOR PARA ÓTICAS.5a356516.pdf";